import { ErrorHandler } from '@angular/core';

declare const DD_RUM: any;

export class DatadogErrorHandler extends ErrorHandler {
  handleError(err: any): void {
    super.handleError(err);
    DD_RUM.onReady(function() {
      DD_RUM.addError(err.originalError || err);
    });
  }
}
